export enum SettingsTabNames {
  Passport,
  Discover,
}
